export const MODE = {
	unchecked_prompt: 'unchecked_prompt',
	unchecked_progress: 'unchecked_progress',
	sellable_prompt: 'sellable_prompt',
	sellable_progress: 'sellable_progress',
	sellable_done: 'sellable_done',
	enrollable_prompt: 'enrollable_prompt',
	enrollable_progress: 'enrollable_progress',
	enrollable_done: 'enrollable_done',
	waitable_prompt: 'waitable_prompt',
	waitable_disabled: 'waitable_disabled',
	unavailable: 'unavailable',
};

export const MODE_LABELS = {
	unchecked_prompt: 'Add to Cart',
	unchecked_progress: 'Checking...',
	sellable_prompt: 'Add to Cart',
	sellable_progress: 'Adding...',
	sellable_done: 'Go to Checkout',
	enrollable_prompt: 'Enroll Now',
	enrollable_progress: 'Enrolling...',
	enrollable_done: 'Go to Dashboard',
	waitable_prompt: 'Join Waitlist',
	waitable_disabled: 'Sold Out',
	unavailable: 'Unavailable'
}
